import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { CSSmainLayout, Flex } from "./Uikit";
import { User } from "./User";

export function Header(props) {
  const { handleCat, active, stackMode } = { ...props };
  return (
    <CSSheader>
      <CSSmainLayout middle style={{ height: "5em" }}>
        <Flex left>
          {!stackMode && <CSSlogo>META&nbsp;Nutrition™</CSSlogo>}
        </Flex>

        <Flex center>
          {!stackMode && (
            <CSSswitch0>
              <CSSswitch
                active={active === "goal"}
                onClick={() => handleCat("goal")}
              >
                Goals
              </CSSswitch>
              <CSSswitch
                active={active === "categories"}
                onClick={() => handleCat("categories")}
              >
                Categories
              </CSSswitch>
            </CSSswitch0>
          )}
        </Flex>

        <Flex right>
          <CSSuser>
            <User />
          </CSSuser>
        </Flex>
      </CSSmainLayout>
    </CSSheader>
  );
}

const CSSheader = styled.div`
  padding-top: 1em;
  margin-bottom: 2em;
  position: relative;
  z-index: 0;
  @media (max-width: 991px) {
    margin-bottom: 2em;
  }
`;

const CSSuser = styled.div`
  @media (max-width: 991px) {
    position: absolute;
    top: 2em;
    right: 2em;
  }
  @media (max-width: 991px) {
    top: 1em;
    right: 1em;
  }
`;

const CSSswitch0 = styled.div`
  display: flex;
  /* width: 100%; */
  margin-bottom: 1em;
  border-radius: 0.4em;
  overflow: hidden;
  padding: 0.5em;
  box-shadow: 0px 5px 12px -3px rgba(106, 96, 96, 0.05), 0px 7px 60px -16px rgba(106, 96, 96, 0.1);
  @media (max-width: 991px) {
    box-shadow: 0px 5px 12px -3px rgba(106, 96, 96, 0);
    padding: 0em;
    margin: 1em 0 1em 0;
    width: 100%;
  }
`;

const CSSswitch = styled.div`
  line-height: 1em;
  border-radius: 0.45em;
  flex-grow: 1;
  color: ${({ active }) =>
    active
      ? "var(--main-accent-text-color)"
      : "var(--main-text-lighter-color)"};
  font-weight: 600;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  padding: 0.9em 2em 1em 2em;
  background: ${({ active }) =>
    active ? "var(--main-text-color)" : "transparent"};
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }

`;

const CSSlogo = styled.h2`
  position: absolute;
  font-size: 2em;
  @media (max-width: 1280px) {
    font-size: 1.4em;
  }
  @media (max-width: 991px) {
    position: relative;
    font-size: 2.4em;
  }

`;
